// extracted by mini-css-extract-plugin
module.exports = {"tabsLand":"setPayword_tabsLand__2wLS1","formlabelExtra":"setPayword_formlabelExtra__Z08Yg"};